import React from "react";
import Container from "../components/container";
import SEO from "../components/seo";
import TitleBanner from "../components/titleBanner";
import LinkNewTab from "../components/LinkNewTab";
import { Link } from "gatsby";
import { MailOutlined } from "@ant-design/icons";

function HomePage() {
  return (
    <Container>
      <SEO title="Criz Games" titleAddSuffix={false} />
      <div
        className="mx-auto font-medium md:max-w-2xl"
        style={{
          color: "rgba(0,0,0,0.85)",
        }}
      >
        <TitleBanner title="Hey 👋">
          <div className="text-lg md:text-2xl">
            <p>
              I am a hobby programmer and do mainly stuff in{" "}
              <LinkNewTab to="https://unity.com/">Unity</LinkNewTab>. I write
              most of my code in{" "}
              <LinkNewTab to="https://en.wikipedia.org/wiki/C_Sharp_(programming_language)">
                <span style={{ color: "green" }}>C#</span>
              </LinkNewTab>{" "}
              and I'm interested in games and all kinds of{" "}
              <Link to="/assets/#cgai">AI</Link>.
            </p>
            If you need support for my <Link to="/assets/">assets</Link> or just
            want to contact me, feel free to do so:
            <br />
            <LinkNewTab to="mailto:comp.criz.games@gmail.com">
              <MailOutlined
                className="icon black"
                style={{
                  verticalAlign: "middle",
                }}
              />{" "}
              comp.criz.games@gmail.com
            </LinkNewTab>
          </div>
        </TitleBanner>
      </div>
    </Container>
  );
}

export default HomePage;
